import LeavesTodo from './widgets/LeavesTodo';

export const LeavesTodoWidgets = {
  LEAVES_PUBLISHED: {
    title: () => 'Leaves Title',
    component: LeavesTodo,
  },
};
